import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import {
  FaHome, FaHeart, FaLeaf, FaImage,
  FaFileAlt, FaUsers, FaEnvelope, FaBars, FaTimes
} from "react-icons/fa";
import logo from "../assets/logo.png";

const pages = [
  { name: "Home", icon: <FaHome />, path: "/" },
  { name: "Programs", icon: <FaFileAlt />, path: "/programs" },
  { name: "Health", icon: <FaHeart />, path: "/health" },
  { name: "Environment", icon: <FaLeaf />, path: "/environment" },
  { name: "Gallery", icon: <FaImage />, path: "/gallery" },
  { name: "Reports", icon: <FaFileAlt />, path: "/reports" },
  { name: "Members", icon: <FaUsers />, path: "/members" },
  { name: "Contact", icon: <FaEnvelope />, path: "/contact" },
];

const Navbar = () => {
  const location = useLocation();
  const activePage = pages.find(p => p.path === location.pathname)?.name || "";
  const [showPopup, setShowPopup] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <>
      {/* NAVBAR */}
      <nav style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: isMobile ? '8px 16px' : '8px 35px',
        background: '#f6f7f5',
        boxShadow: '0 2px 5px rgba(0,0,0,0.08)',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img
            src={logo}
            alt="SRV NGO Logo"
            style={{ width: isMobile ? '60px' : '110px', cursor: 'pointer', transition: 'transform 0.3s' }}
            onClick={() => setShowPopup(true)}
          />
          <div>
            <h1 style={{ fontSize: isMobile ? '20px' : '26px', fontWeight: 800, margin: 0, color: '#000' }}>
              SRV NGO
            </h1>
            <p style={{ fontSize: isMobile ? '11px' : '15px', fontWeight: 600, margin: 0, color: '#333' }}>
              Serving Humanity Through Education
            </p>
          </div>
        </div>

        {/* Hamburger - Mobile Only */}
        {isMobile && (
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px',
              color: '#333',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {menuOpen ? <FaTimes size={28} /> : <FaBars size={28} />}
          </button>
        )}

        {/* Desktop Links */}
        {!isMobile && (
          <ul style={{ display: 'flex', gap: '22px', listStyle: 'none', margin: 0, padding: 0, alignItems: 'center' }}>
            {pages.map(page => (
              <li key={page.name}>
                <Link
                  to={page.path}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    textDecoration: 'none',
                    color: activePage === page.name ? '#1d4ed8' : '#1d4ed8',
                    fontWeight: 600,
                    fontSize: '15px',
                    padding: '4px 0',
                  }}
                  className={activePage === page.name ? 'active-link' : ''}
                >
                  <span>{page.icon}</span>
                  <span>{page.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </nav>

      {/* Mobile Dropdown Menu */}
      {isMobile && menuOpen && (
        <div style={{
          position: 'fixed',
          top: '76px',
          left: 0,
          right: 0,
          background: '#fff',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: 999,
          display: 'flex',
          flexDirection: 'column',
        }}>
          {pages.map(page => (
            <Link
              key={page.name}
              to={page.path}
              onClick={() => setMenuOpen(false)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px 20px',
                textDecoration: 'none',
                color: activePage === page.name ? '#1d4ed8' : '#333',
                fontWeight: 600,
                fontSize: '16px',
                borderBottom: '1px solid #f0f0f0',
                background: activePage === page.name ? '#f0f4ff' : 'transparent',
              }}
            >
              <span>{page.icon}</span>
              <span>{page.name}</span>
            </Link>
          ))}
        </div>
      )}

      {/* Logo Popup */}
      {showPopup && (
        <div
          onClick={() => setShowPopup(false)}
          style={{
            position: 'fixed', top: 0, left: 0,
            width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.95)',
            display: 'flex', justifyContent: 'center',
            alignItems: 'center', zIndex: 9999, cursor: 'pointer',
          }}
        >
          <span style={{ position: 'absolute', top: '20px', right: '40px', fontSize: '50px', color: 'white', cursor: 'pointer', fontWeight: 'bold' }}>
            &times;
          </span>
          <img src={logo} alt="Full Logo" style={{ maxWidth: '90%', maxHeight: '90%' }} />
        </div>
      )}
    </>
  );
};

export default Navbar;